import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '@libs/ui-lib';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { CriticalStatus } from '../health-history-item/health-history-item.component';

export type HealthHistoryIconType = CriticalStatus | 'patient-alert';

@Component({
  selector: 'lib-health-history-item-icon',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, TooltipModule, TranslateModule],
  templateUrl: './health-history-item-icon.component.html',
  styleUrl: './health-history-item-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryItemIconComponent {
  public readonly iconType = input.required<HealthHistoryIconType>();
  public readonly grayedOut = input<boolean>(false);

  public readonly tooltipText = computed(() => {
    switch (this.iconType()) {
      case 'critical': {
        return 'health_history_health_history_tab_item_icon_status_critical';
      }
      case 'non-critical': {
        return 'health_history_health_history_tab_item_icon_status_non_critical';
      }
      default: {
        return '';
      }
    }
  });

  public readonly iconColor = computed(() => {
    switch (this.iconType()) {
      case 'critical': {
        return this.grayedOut() ? 'text-text-light' : 'text-states-red';
      }
      case 'non-critical': {
        return this.grayedOut() ? 'text-text-extra-light' : 'text-primary-blue';
      }
      case 'patient-alert': {
        return this.grayedOut() ? 'text-text-extra-light' : 'text-states-orange';
      }
    }
  });
}
